import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const UsageChart = ({ data }) => {
  // Transform data for the chart
  const chartData = data?.weekly?.map(item => ({
    day: item.day,
    prompts: item.prompts
  })) || [];

  return (
    <div className="usage-chart-container">
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={chartData}>
          <XAxis
            dataKey="day"
            stroke="#aaa"
            fontSize={12}
          />
          <YAxis
            stroke="#aaa"
            fontSize={12}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1a1a1a',
              border: '1px solid #333',
              borderRadius: '8px',
              color: '#fff'
            }}
          />
          <Line
            type="monotone"
            dataKey="prompts"
            stroke="#3b82f6"
            strokeWidth={3}
            dot={{ r: 4, fill: '#3b82f6' }}
            activeDot={{ r: 6, fill: '#60a5fa' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UsageChart;
